module.exports = __webpack_public_path__ + "components/country-flag/static/gt-340128f2656647dc0f5e2917ca11682f.svg";